export default __webpack_public_path__ + "static/media/hit.a48e6b4a.mp3";